<template>
  <v-row class="TitleWithButton">
    <v-col align-self="center" class="py-0">
      {{ title }}
    </v-col>

    <slot name="before-create" />

    <template v-if="creatable">
      <v-col cols="auto" class="py-0 pr-4 TitleWithButton__button-container">
        <v-skeleton-loader :loading="skeleton" type="button">
          <v-btn
            :loading="isLoading"
            dense
            depressed
            small
            class="pl-2"
            @click.stop="$emit('create', toggleLoading)"
          >
            <v-icon class="mr-1" size="20px" v-text="buttonIcon" />
            {{ buttonText }}
          </v-btn>
        </v-skeleton-loader>
      </v-col>
    </template>
  </v-row>
</template>

<script>
export default {
  name: 'TitleWithButton',
  props: {
    title: {
      type: String,
      required: true,
    },
    buttonText: String,
    buttonIcon: {
      type: String,
      default: 'mdi-plus',
    },
    creatable: Boolean,
    createUrl: String,
    skeleton: Boolean,
  },
  data: () => ({
    isLoading: false,
  }),
  methods: {
    toggleLoading() {
      this.isLoading = !this.isLoading
      return this.toggleLoading
    },
  },
}
</script>

<style lang="scss">
.TitleWithButton {
  margin-top: -10px;
  margin-bottom: -10px;
}
</style>
